import React, { FC, useEffect } from 'react';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { WindowExtended } from '../../types';
import { showCloudinaryWidget } from '../../services/widget-service';
import { useAuth, useWidgetConfiguration } from '../../selectors';
import { useInsertMediaHandler } from '../../hooks/useInsertMediaHandler';

const Root = styled.div`
  height: 100%;
`;

export const Widget: FC = () => {
  const auth = useAuth();
  const insertMediaHandler = useInsertMediaHandler();
  const configuration = useWidgetConfiguration();

  useEffect(() => {
    if (!isEmpty(configuration)) {
      showCloudinaryWidget({ ...auth, ...configuration }, window as unknown as WindowExtended, { insertHandler: insertMediaHandler });
    }
  }, [configuration, auth, insertMediaHandler]);

  return (
    <Root id="widget_container" />
  );
};
